import { Injectable } from '@angular/core';

const CACHE_LIMIT = 15;

interface CacheItem<T> {
  key: string;
  value: T;
}

@Injectable()
export class SearchCacheService<T = any> {
  private cacheArray: CacheItem<T>[] = [];

  get(url: string): T {
    const item = this.cacheArray.find((i) => i.key === url);
    if (item) {
      return item.value;
    } else {
      return null;
    }
  }

  put(url: string, results: T) {
    this.cacheArray.push({ key: url, value: results });
    // TODO put cache side into configuration
    while (this.cacheArray.length > CACHE_LIMIT) {
      this.cacheArray.shift();
    }
  }

  clear(baseUrl: string) {
    this.cacheArray = this.cacheArray.filter(
      (item) => !item.key.startsWith(baseUrl)
    );
  }
}
